<script>
export let total;
export let page;
</script>

{#each Array(total) as _, i}
  <div class='rounded-full w-4 h-4 border border-black flag:bg-[var(--color)] flag:border-none' class:flag={page === i} />
{/each}